/* eslint-ignore-file */
import React, { useState } from 'react';
import { images, sociallinks } from '../../constants';
import { motion } from 'framer-motion';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../Sanityclient';
import './Footer.scss';

const Footer = () => {
  const openSocial = (link) => {
    window.open(link, '_blank');
  };
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    subject: '',
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [setLoading] = useState(false);
  const [error, setError] = useState('');
  const { username, email, message, subject } = formData;
  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = () => {
    if (username === '' || email === '' || message === '' || subject === '') {
      setLoading(false);
      setError('Please fill all fields');
    } else if (
      email.includes('@gmail.com') ||
      email.includes('@outlook.com') ||
      email.includes('@hotmail.com') ||
      email.includes('@yahoo.com') ||
      email.includes('@' && '.org')
    ) {
      setError('');
      setLoading(true);
      const contact = {
        _type: 'contact',
        name: formData.username,
        email: formData.email,
        subject: formData.subject,
        message: formData.message,
      };
      client
        .create(contact)
        .then(() => {
          setLoading(false);
          setIsFormSubmitted(true);
        })
        .catch((err) => console.log(err));
    } else {
      setLoading(false);
      setError('Enter A Valid Email Address');
    }
  };
  return (
    <>
      <h2 className="head-text">
        <span>You Can Get In Touch</span> by Sending{' '}
        <span>Me a Message Here</span>
      </h2>

      <div className="app__footer-cards">
        <motion.div
          onClick={() => {
            openSocial(sociallinks.email);
          }}
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.2, type: 'tween' }}
          className="app__footer-card "
        >
          <img src={images.email} alt="email" />
          <p className="p-text">E-MAIL</p>
        </motion.div>
        <motion.div
          onClick={() => {
            openSocial(sociallinks.discordserver);
          }}
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.2, type: 'tween' }}
          className="app__footer-card"
        >
          <img src={images.discord} alt="discord" />
          <p className="p-text">DISCORD</p>
        </motion.div>
      </div>
      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input
              className="p-text"
              type="text"
              placeholder="Your Name"
              name="username"
              value={username}
              onChange={handleChangeInput}
              required
            />
          </div>
          <div className="app__flex">
            <input
              className="p-text"
              type="email"
              placeholder="Your Email"
              name="email"
              value={email}
              onChange={handleChangeInput}
              required
            />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
              required
            />
          </div>
          <button onClick={handleSubmit}>button</button>
          {!!error && (
            <div>
              <div className="p-err">{error}</div>
            </div>
          )}
        </div>
      ) : (
        <div>
          <h3 className="head-text">
            <span>Thanks For</span> Getting <span>In Touch!</span>
          </h3>
        </div>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);
